import React, { useEffect, useState } from 'react'
import {
  CalendarToolbarContainer,
  CalendarToolbarDay,
  CalendarToolbarDayNumber,
  CalendarToolbarDescriptionContainer,
} from './CalendarToolbar.styled'
import SVG from 'react-inlinesvg'
import arrowLeftIcon from 'assets/icons/arrow-left-calendar.svg'
import arrowRightIcon from 'assets/icons/arrow-right-calendar.svg'
import { CalendarToolbarProps } from './CalendarToolbar.props'
import moment from 'moment'

const CalendarToolbar = ({ currentDate, onSelectedDate }: CalendarToolbarProps) => {

  const MONTH_NAMES = moment.months();

  const [cDate, setCDate] = useState<Date>(currentDate);

  useEffect(() => setCDate(currentDate), [currentDate])

  const getDay = () => moment(cDate).format('Do');
  const getDayWeek = () => moment(cDate).format('dddd');
  const getMonth = () => MONTH_NAMES[cDate.getMonth()];

  const handleToolbarDay = (type: 'prev' | 'add') => {
    const newDate = cDate;
    type === 'add'
      ? newDate.setDate(newDate.getDate() + 1)
      : newDate.setDate(newDate.getDate() - 1);

    setCDate(newDate);
    onSelectedDate(newDate);
  }

  return (
    <CalendarToolbarContainer>
      <SVG
        src={arrowLeftIcon}
        onClick={() => handleToolbarDay('prev')}
        style={{ marginLeft: 29, cursor: 'pointer' }}
      />
      <CalendarToolbarDescriptionContainer>
        <CalendarToolbarDay>
          {getDayWeek()}, {getMonth()}
        </CalendarToolbarDay>
        <CalendarToolbarDayNumber>{getDay()}</CalendarToolbarDayNumber>
      </CalendarToolbarDescriptionContainer>
      <SVG
        src={arrowRightIcon}
        onClick={() => handleToolbarDay('add')}
        style={{ marginRight: 29, cursor: 'pointer' }}
      />
    </CalendarToolbarContainer>
  )
}

export default CalendarToolbar
